import { revitBimImage, revitBimLayers } from "@/mocks/serviceRevitData";

export default function RevitBim() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal relative h-[320px] md:h-[480px] rounded-lg overflow-hidden">
            <img
              src={revitBimImage}
              alt="Modelo BIM 3D de un edificio con capas separadas de arquitectura, estructura y sistemas mecánicos"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
              Metodología BIM
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              ¿Qué es la metodología BIM?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              BIM (Building Information Modeling) es una metodología que permite crear y gestionar
              representaciones digitales de un proyecto durante sus diferentes etapas.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {revitBimLayers.map((layer, i) => (
                <div
                  key={layer.title}
                  className="reveal flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                  style={{ transitionDelay: `${i * 60}ms` }}
                >
                  <div className="w-9 h-9 rounded-lg bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center shrink-0">
                    <i className={`${layer.icon} text-lg`} />
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1 leading-snug">
                      {layer.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-snug">{layer.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}